<template>
  <button id="KEY_B" name="B" class="btn softkey-btn" aria-label="B" data-vcode="COLOR_KEY_1">
    <img src="/images/icn-softkey-B.svg" alt="" role="img" aria-hidden="true" />
  </button>
</template>
<script>
export default {};
</script>
